import { CREATE_PRODUCT, GET_PRODUCT, GET_PRODUCTS, GET_STORE_PRODUCTS, GET_SUBCATEGORIES } from './ApiConstants';
import api from './ApiHandler';
import { downloadFile } from './DownloadHandler';

export const getProductsList = async ({
  page,
  limit,
  entityId
}: {
  page: number;
  limit: number;
  entityId: any;
}) => {
  return await api.get(GET_PRODUCTS, { params: { page, limit, entityId } });
};

interface CreateProductPayloads {
  productName: string;
  categoryId: string;
  subcategoryId: string;
  description: string;
  price: number;
  productType: string;
  ingredients: [
    { ingredient: string; unit: string; quantity: number; price: number },
    { ingredient: string; unit: string; quantity: number; price: number }
  ];
  nutritions: [{ nutrition: string; unit: string; quantity: number; percent: number }];
  productSKU: string;
  status: string;
}

export const createProduct = async (payload: CreateProductPayloads) => {
  return await api.post(CREATE_PRODUCT, {
    ...payload
  });
};

export const getProductsByPage = async (payload: any) => {
  return await api.get(GET_STORE_PRODUCTS, { params: payload });
};

export const getProduct = async (payload: any) => {
  return await api.get(GET_PRODUCT, { params: payload });
};

export const getSubCategories = async ({ categoryId }: { categoryId: string }) => {
  return await api.get(GET_SUBCATEGORIES, { params: { categoryId } });
};
